import { useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import RoleGeneralInformation from './GeneralInformation'
import RoleDetailsGroups from './Groups'

import BackNavigation from '~/components/BackNavigation'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'
import Layout from '~/components/Layouts/Layout'
import MwMLoader from '~/components/MwMLoader'
import ViewTitle from '~/components/ViewTitle'
import { useRoleDetailsQuery } from '~/queries/user-roles'
import { capitalize } from '~/utils/string'

const RoleDetails = (): ReactElement | null => {
  const { roleId } = useParams<{ roleId: string }>()

  const { data: role, isLoading } = useRoleDetailsQuery(roleId)

  if (isLoading) {
    return (
      <Layout>
        <MwMLoader category="item" />
      </Layout>
    )
  }

  if (!role) {
    return null
  }

  const { description, name, role_id, updated_at_ts, updated_by } = role

  const updatedBy = {
    date: updated_at_ts,
    name: updated_by.name,
    picture: updated_by.picture,
  }

  return (
    <Layout>
      <ViewTitle className="flex justify-space-between">
        <BackNavigation title="Roles" to="/mwm-users/roles" />
        <div className="flex align-center justify-center">Role detail</div>
        <LastUpdatedByCard updatedBy={updatedBy} />
      </ViewTitle>
      <RoleGeneralInformation description={description} id={role_id} name={capitalize(name)} />
      <RoleDetailsGroups role={role} />
    </Layout>
  )
}

export default RoleDetails
